// import { useState } from 'react';
// import { TableInput } from '../../../components/common';

// import CustomSelect from '../../../components/common/SelectField';
// import { IconButton, MenuItem, Tooltip } from '@mui/material';

// import DeleteIcon from '@mui/icons-material/Delete';
// import { useQuery } from '../../../hooks/UseQuery';
// import DatePickerMui from '../../../components/common/DatePickerMui';
// import formatDate from '../../../components/common/formatDate';
// import moment from 'moment';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const TBody = ({ moduleData, isView }: IProps) => {
  return (
    <tbody>
      {moduleData?.specs?.length > 0 &&
        moduleData.specs.map((item: any, index: number) => (
          <tr key={`${index}_tbody`}>
            <td style={{ width: '80px' }}>{index + 1}</td>
            <td>{item.parameter}</td>
            <td>{item.control_product}</td>
            <td>{item.methods_measure}</td>
            <td style={{ width: '180px' }}>{item.methods_size}</td>
            <td style={{ width: '180px' }}>{item.methods_by}</td>
            <td style={{ width: '100px' }}>{item.recording}</td>
            <td style={{ width: '100px' }}>{item.responsibility}</td>
            <td>{item.reaction_plan}</td>
          </tr>
        ))}
      <tr>
        <th colSpan={9}>
          LEGENDS : P - PATROLLING INSPECTOR ; DS - DIE SETTER ; W - OPERATOR ;
          E - ENGINEER ; I - INSPECTOR ; Y - YES ; N - NO
        </th>
      </tr>
      <tr>
        <th colSpan={9} align="left" style={{ fontSize: '2rem' }}>
          Revision History :-
        </th>
      </tr>
      <tr>
        <th colSpan={1}>S.No.</th>
        <th colSpan={1}>Date</th>
        <th colSpan={5}>Details of Change</th>
        <th colSpan={2}>Revised By</th>
      </tr>
    </tbody>
  );
};

export default TBody;
